// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__3GUtM","choiceBoxes":"toolbarselects_choiceBoxes__AOEbW","simpleField":"toolbarselects_simpleField__P1FOR"};